const resource = '/admin/v1/users';

export default $axios => ({
  index(payload) {
    return $axios.get(`${resource}/search`, {params: payload});
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  updateStatus(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  bridgeLoginByUserId(id) {
    return $axios.get(`${resource}/${id}/bridge-login`);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  info() {
    return $axios.get('admin/v1/auth/info');
  },

  login({uid, password}) {
    return $axios.post('admin/v1/auth/login', {uid, password});
  },

  logout() {
    return $axios.get('admin/v1/auth/logout');
  }
});
